import { PureComponent, PropsWithChildren } from "react";

export default class SubsectionFooter extends PureComponent<PropsWithChildren> {
  render() {
    const { children } = this.props;

    return <div className="ct-subsection__footer">{children}</div>;
  }
}
